import React, { useState, useEffect } from 'react';
import { useAppData } from '../../AppContext';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Back from '../Back';
import Task from './Task';
import DailyReword from './DailyReword';
import Footer from '../Footer/Footer';
import { completeTask, seeTask, completeFriendsTask, claimDailyRewords } from '../../http';
import coin from "./TaskImg.png";
import dollar_coin from '../../pages/dollar_coin.png';
import calender from './calenderFull.png';
import "./tasks.scss";
import './dailyreword.scss';

export const Tasks = () => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState('tasks');
    const [selectedMeme, setSelectedMeme] = useState(null);
    const location = useLocation();
    const { tasks, setTriggerRender, handleEditCoins, getUserDaylysData, dailys } = useAppData();

    useEffect(() => {
        if (location.pathname.includes('/earn/tasks')) {
            setActiveTab('tasks');
        } else if (location.pathname.includes('/earn/income')) {
            setActiveTab('income');
        } else if (location.pathname.includes('/earn/craft')) {
            setActiveTab('craft');
        }
    }, [location]);

    const [selectedTask, setSelectedTask] = useState(null);
    const [selectedDaily, setSelectedDaily] = useState(null);

    const handleTaskClick = (task) => {
        setSelectedTask(task);
    };

    const handleDailyClick = () => {
        setSelectedDaily(true);
    };

    const handleFriendsMoadalTaskClick = async (id, task__coins_reward, status) => {
        try {
            const result = await completeFriendsTask();
            const checkedValue = result.checked;
            if (status) {
                if (checkedValue) {
                    await completeTask(id);
                    handleEditCoins(task__coins_reward);
                }
            } else {
                seeTask(id);
            }
            handleCloseModal();
            forceUpdate();
        } catch (error) {
            console.error("Failed to complete task", error);
        }
    };

    const handleMoadalTaskClick = async (link, id, task__coins_reward, status) => {
        try {
            if (status) {
                await completeTask(id);
                handleEditCoins(task__coins_reward);
            } else {
                seeTask(id);
            }
            openLink(link);
            handleCloseModal();
            forceUpdate();
        } catch (error) {
            console.error("Failed to complete task", error);
        }
    };

    const handleCloseModal = () => {
        setSelectedTask(null);
        setSelectedDaily(null);
    };

    const forceUpdate = () => setTriggerRender(prev => !prev);

    function openLink(link) {
        if (window.Telegram.WebApp) {
            window.Telegram.WebApp.openLink(link);
        }
    }

    const formatNumber = (num) => {
        if (num >= 1000000000) {
            return (num / 1000000000).toFixed(0) + 'B';
        } else if (num >= 1000000) {
            return (num / 1000000).toFixed(0) + 'M';
        } else if (num >= 1000) {
            return (num / 1000).toFixed(0).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 3 }) + 'K';
        }
        return num;
    };

    const handleClaimReword = async () => {
        try {
            await claimDailyRewords();
            // const checkedValue = result.checked;
            // if (status) {
            //     if(checkedValue) {
            //         await completeTask(id);
            //         handleEditCoins(task__coins_reward);
            //     } 
            // } else {
            //     seeTask(id);
            // }
            handleCloseModal();
            forceUpdate();
        } catch (error) {
            console.error("Failed to clain reword", error);
        }
    }

    const areAllRewardsUnavailable = dailys.every(dayReward => dayReward.status !== 'Available');

    return (
        <div className='container_glow_shop'>
            <Back />

            <div className="tab-header tasks">
                <img src={coin} className="tab_img_tasks" draggable="false" alt="Coin" />
                <h2 className="tab-title">Earn more coins</h2>
            </div>

            {/* <div className='daily_text first'>Daily tasks</div>
            <div className='shop_grid first'>
                <DailyReword onClick={handleDailyClick} />
            </div> */}
            <div className="space" />

            <div className='daily_text'>Tasks list</div>

            <div className='shop_grid'>
                {activeTab === 'tasks' && tasks.map((task) => (
                    <Task
                        key={task.id}
                        task={task.task__name}
                        icon={task.task__logo || test}
                        coins={`+${task.task__coins_reward}`}
                        status={task.status}
                        onClick={() => handleTaskClick(task)}
                    />
                ))}
            </div>

            {selectedTask && (
                <div className="modal">
                    <div className="modal-container-tasks">
                        <span className="close" onClick={handleCloseModal}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" fill="#CACACA" fill-opacity="0.46" />
                                <path d="M16 8L8 16" stroke="#131313" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 8L16 16" stroke="#131313" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                        <div className="modal-content_tasks">
                            <img src={selectedTask.task__logo || test} className="modal_image_tasks" alt="Task icon" />
                            <h2 className='modal-title'>{selectedTask.task__name}</h2>
                            {selectedTask.task__link !== "TG" ? (
                                <button className='button_tasks_join' onClick={() => handleMoadalTaskClick(selectedTask.task__link, selectedTask.id, selectedTask.task__coins_reward, selectedTask.status)}>Join</button>
                            ) : (
                                <> </>
                            )}
                            <div className='coins_container_tasks'>
                                <img src={dollar_coin} className="coin_icon_modal_tasks" alt="Coin-icon" />
                                +{selectedTask.task__coins_reward}
                            </div>

                            {selectedTask.task__link === "TG" ? (
                                selectedTask.is_seen ?
                                    <button className='open_task button_tasks' onClick={() => handleFriendsMoadalTaskClick(selectedTask.id, selectedTask.task__coins_reward, selectedTask.status)}>Take Reward</button>
                                    :
                                    <button className='open_task button_tasks' onClick={() => handleFriendsMoadalTaskClick(selectedTask.id, selectedTask.task__coins_reward, selectedTask.status)}>{t('taskspage.openTask')}</button>
                            ) : (
                                selectedTask.is_seen ?
                                    <button className='open_task button_tasks' onClick={() => handleMoadalTaskClick(selectedTask.task__link, selectedTask.id, selectedTask.task__coins_reward, selectedTask.status)}>Take Reward</button>
                                    :
                                    <button className='open_task button_tasks' onClick={() => handleMoadalTaskClick(selectedTask.task__link, selectedTask.id, selectedTask.task__coins_reward, selectedTask.status)}>{t('taskspage.openTask')}</button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {selectedDaily && (
                <div className="modal">
                    <div className="modal-container-tasks">
                        <span className="close" onClick={handleCloseModal}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" fill="#CACACA" fill-opacity="0.46" />
                                <path d="M16 8L8 16" stroke="#131313" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 8L16 16" stroke="#131313" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                        <div className="modal-content_tasks dailyReword">
                            <img className='calender_icon' src={calender} alt="Calendar" />
                            <div className="dailyInfo">
                                <h2>Daily Task</h2>
                                <p className='dailyText'>Accrue coins for logging into the game daily without skipping</p>
                            </div>
                            <div className="rewords">
                                {dailys.map(dayReward => (
                                    <div className={`reword ${dayReward.status}`} key={dayReward.day}>
                                        <h3>Day {dayReward.task__day_number}</h3>
                                        <img src={dollar_coin} alt="coin" />
                                        <p className='rewordValue'>{formatNumber(dayReward.task__coins_reward)}</p>
                                    </div>
                                ))}
                            </div>
                            <button
                                className={`open_task button_tasks ${areAllRewardsUnavailable ? 'disabled' : ''}`}
                                onClick={areAllRewardsUnavailable ? handleCloseModal : handleClaimReword}
                            >
                                {areAllRewardsUnavailable ? 'Come back tomorrow' : 'Claim'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};
